import {Button} from "@/components/button/Button.tsx";
import styles from "./SubscribeDropdown.module.scss";

export interface SlackTabContentProps {
  serverError: string | null;
  slackOAuthUrl: string;
}

export const SlackTabContent = ({serverError, slackOAuthUrl}: SlackTabContentProps) => (
  <div className={styles.formContent}>
    <p className={styles.tabTitle}>Subscribe via Slack</p>
    {serverError && (
      <p className={styles.errorText} role="alert">
        {serverError}
      </p>
    )}
    <Button
      as="a"
      href={slackOAuthUrl}
      target="_blank"
      rel="noopener noreferrer"
      variant="primary"
      size="small"
      className={styles.submitBtn}
    >
      Connect Slack Channel
    </Button>
  </div>
);
